import { Drawer } from 'antd'
import React from 'react'

import { drawerAndModalWidth } from '../../../util/guideline'
import { UpdateTenantRatesheet } from './UpdateTenantRatesheet'

interface UpdateTenantRatesheetProps {
  tenantDomain: string
  tenantName: string
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const UpdateTenantRatesheetDrawer = ({
  tenantDomain,
  tenantName,
  isVisible,
  onClose,
  onSuccess,
}: UpdateTenantRatesheetProps) => (
  <Drawer
    title="Update Tenant Ratesheet"
    placement="right"
    onClose={onClose}
    open={isVisible}
    width={drawerAndModalWidth}
    destroyOnClose
  >
    <UpdateTenantRatesheet tenantName={tenantName} tenantDomain={tenantDomain} onSuccess={onSuccess} />
  </Drawer>
)
